import { Link } from '@tanstack/react-router'
import {
  LayoutDashboard,
  HardDrive,
  ArrowUpRight,
  ShieldCheck,
} from 'lucide-react'
import { Brand } from './brand'
import { PharmacyNavigation } from './pharmacy-navigation'
export function SidebarContent({
  dashboard = false,
  pos = false,
}: {
  dashboard?: boolean
  pos?: boolean
}) {
  if (dashboard) return <PharmacyNavigation pos={pos} />
  return (
    <>
      <div className="sidebar-brand">
        <Brand />
      </div>
      <div className="sidebar-store">
        <span className="store-initial">P</span>
        <div>
          <strong>Pare Pharmacy</strong>
          <span>พื้นที่ทำงานของร้าน</span>
        </div>
        <ShieldCheck size={17} />
      </div>
      <span className="nav-label">พื้นที่ทำงาน</span>
      <nav aria-label="เมนูหลัก">
        <Link
          to="/"
          activeOptions={{ exact: true }}
          activeProps={{ className: 'active' }}
        >
          <LayoutDashboard size={20} /> ภาพรวม <span className="nav-dot" />
        </Link>
        <Link to="/offline" activeProps={{ className: 'active' }}>
          <HardDrive size={20} /> ตรวจสอบอุปกรณ์{' '}
          <ArrowUpRight size={15} className="nav-end" />
        </Link>
      </nav>
      <div className="sidebar-bottom">
        <span className="foundation-tag">FOUNDATION</span>
        <p>
          วางรากฐานวันนี้
          <br />
          พร้อมเติบโตไปกับร้าน
        </p>
        <span className="sidebar-version">Pare POS · v0.1.0</span>
      </div>
    </>
  )
}
